import { FormControl, FormLabel, HStack, Input } from "@chakra-ui/react";
import React from "react";

const FormikInput = ({ formik, labelText, field, isRequired }) => {
  return (
    <FormControl isRequired={isRequired}>
      <HStack>
        <FormLabel whiteSpace="nowrap" mb={0}>
          {labelText}
        </FormLabel>
        <Input variant="filled" {...formik.getFieldProps(field)} />
      </HStack>
    </FormControl>
  );
};

export default FormikInput;
